// extracted by mini-css-extract-plugin
export default {"container":"details_container__ivdL4","wrapper":"details_wrapper__ERiKx","heading":"details_heading__1mYa3","data":"details_data__lfk8Q","description":"details_description__6hfxY"};